import { PayeeRoyalties } from '@Entities/statements/payee-royalties'
import { payeeActivityDownload } from '@App/api/routes/rightsholder/statements'
import React, { useContext } from 'react'
import DownloadLink from '@Components/Utility/DownloadLink'
import { StoresContext } from '@App/contexts'
import { NO_PAYEE_ACTIVITY } from '@Const/error-messages'

interface RightsholderRoyaltiesPayeeDownloadLinkProps {
    payeeRoyalties: PayeeRoyalties
    useNewLink?: boolean
}

const RightsholderRoyaltiesPayeeDownloadLink = ({
    payeeRoyalties,
    useNewLink,
}: RightsholderRoyaltiesPayeeDownloadLinkProps) => {
    const { popupStore } = useContext(StoresContext)

    const fetchAnnualDownloadLink = async (row: PayeeRoyalties): Promise<string> =>
        payeeActivityDownload(useNewLink ? row.newPasLink.substring(1) : row.pasLink.substring(1))
            .then(async (response) => Promise.resolve(response.data.downloadLink.toString()))
            .catch(() => popupStore.setAlertData(NO_PAYEE_ACTIVITY, true))

    return <DownloadLink fetchLink={() => fetchAnnualDownloadLink(payeeRoyalties)} />
}
export default RightsholderRoyaltiesPayeeDownloadLink
